export default "__VITE_ASSET__CXuLndPj__"